import type { FC } from "react";

type TooltipCloudEdgeProps = Record<string, never>;

export const TooltipCloudEdge: FC<TooltipCloudEdgeProps> = (_props) => {
  return (
    <svg
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.1641 6.50385C7.37246 7.69131 5.62754 7.69131 4.8359 6.50385L0.500001 -1.04907e-06L12.5 0L8.1641 6.50385Z"
        fill="white"
      />
    </svg>
  );
};
